import * as React from "react";
import { Button, Checkbox, Popover, Space } from "antd";
import { useEditModeState, useIsOfferingEditing } from "./EditModeContext";

type SchoolOption = {
  value: number | string;
  label: React.ReactNode;
  labelText?: string;
};

export const SchoolsEditPopover: React.FC<{
  selectedIds: number[];
  options: SchoolOption[];
  onChange: (nextIds: number[]) => void;
  rowEditable?: boolean;
  offeringKey: string;
  viewContent: React.ReactNode;
}> = ({
  selectedIds,
  options,
  onChange,
  rowEditable = true,
  offeringKey,
  viewContent,
}) => {
  const { editMode, setEditingOfferingKey } = useEditModeState();
  const offeringEditing = useIsOfferingEditing(offeringKey);
  const canEdit = offeringEditing && rowEditable;
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (!canEdit) setOpen(false);
  }, [canEdit]);

  if (!canEdit) {
    return (
      <div
        onClick={(e) => {
          if (editMode && rowEditable) {
            e.stopPropagation();
            setEditingOfferingKey(offeringKey);
          }
        }}
      >
        {viewContent}
      </div>
    );
  }

  const content = (
    <div style={{ maxHeight: 280, overflowY: "auto", minWidth: 180, padding: 4 }}>
    <Checkbox.Group
      value={selectedIds}
      style={{ width: "100%" }}
      onChange={(values) => {
        const nextIds = (values as Array<number | string>)
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id));
        onChange(nextIds);
      }}
    >
      <Space orientation="vertical" size={4} style={{ width: "100%" }}>
        {options.map((opt) => {
          const text =
            opt.labelText ??
            (typeof opt.label === "string" ? opt.label : String(opt.value));
          return (
            <Checkbox key={String(opt.value)} value={Number(opt.value)}>
              {text}
            </Checkbox>
          );
        })}
      </Space>
    </Checkbox.Group>
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger={["click"]}
      placement="bottomLeft"
      content={content}
      destroyOnHidden
      getPopupContainer={() => document.body}
    >
      <Button
        size="small"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {selectedIds.length} selected
      </Button>
    </Popover>
  );
};